<!--
 * @Author: zhanghan
 * @Date: 2021-01-23 21:55:45
 * @LastEditors: zhanghan
 * @LastEditTime: 2022-07-08 10:12:09
 * @Descripttion:
-->
<template>
  <div>
    <div id="gitalk-container"></div>
  </div>
</template>
<script>
import Gitalk from "gitalk";
import "gitalk/dist/gitalk.css";

export default {
  name: "comment",
  data() {
    return {};
  },
  mounted() {
    const commentConfig = {
      clientID: "9401eecf2a6a217670d7",
      clientSecret: "e86fc9cf02aedcdf13735dd4f223e1cb823800db",
      repo: "myBlog",
      owner: "abu3389",
      // 这里接受一个数组，可以添加多个管理员
      admin: ["abu3389"],
      // id 用于当前页面的唯一标识，一般来讲 pathname 足够了，
      // 但是如果你的 pathname 超过 50 个字符，GitHub 将不会成功创建 issue，此情况可以考虑给每个页面生成 hash 值的方法.
      id: this.$route.query.articleId.substr(0, 50),
      distractionFreeMode: false,
      proxy:
        "https://gitalk-proxy.abu3389.workers.dev/?https://github.com/login/oauth/access_token"
    };
    const gitalk = new Gitalk(commentConfig);
    gitalk.render("gitalk-container");
  }
};
</script>



// WEBPACK FOOTER //
// comment.vue?c741f490